import { LandingPodDescription, LandingPodItems, type LandingPods } from './';

function OfferChoicePage({ landingPods }: { landingPods: LandingPods }) {
  return (
    <div
      className="flex flex-col md:flex-row min-h-dvh"
      data-track-feature="Multi Offer Choice"
      data-track-container="Promotion"
      data-track-type="multi-offer"
      data-track-expiry-date={landingPods.expiresAt}
    >
      {/* Offer Panel - 50% width on desktop, full width on mobile, visible on first step on mobile */}
      <aside
        className={'md:w-1/2 flex flex-col justify-center bg-background-inverse dark:bg-backround text-foreground-inverse md:flex'}
        data-track-container="Value Proposition"
        data-testid="offer-panel"
      >
        <LandingPodDescription title={landingPods.title} description={landingPods.description} expiresAt={landingPods.expiresAt} image={landingPods.img} />
      </aside>

      {/* Content Panel - 50% width on desktop, full width on mobile */}
      <div className={'md:w-1/2 flex flex-col flex-1 bg-background -mt-2 rounded-s-lg rounded-e-lg md:mt-0 md:rounded-none'}>
        <section className="flex flex-col flex-1 h-full w-full justify-start">
          <div className="w-full flex flex-col flex-1 self-center md:justify-center gap-6 p-6 pt-10 md:p-10 md:max-w-2xl">
            <LandingPodItems landingPods={landingPods} />
          </div>
        </section>
      </div>
    </div>
  );
}

export { OfferChoicePage, type LandingPods };
